import Api from './axiosInstance'
import { API_FTP_PROFILE } from 'utils/constants'
import { FtpProfileFormData } from 'components/ftpProfiles/utils'

const { FTP_PROFILE } = API_FTP_PROFILE

type FetchFtpProfilesParams = {
  limit: number
  page: number
  search?: string
}

// get all FTP Profiles
const fetchFtpProfiles = ({ limit, page, search }: FetchFtpProfilesParams) => {
  const params = new URLSearchParams({
    limit: String(limit),
    page: String(page),
  })

  if (search) {
    params.append('search', search)
  }

  return Api.get({ url: `${FTP_PROFILE}?${params.toString()}` })
}

// get a single FTP Profile
const fetchFtpProfile = (id: string) => {
  return Api.get({ url: `${FTP_PROFILE}/${id}` })
}

// create a new FTP Profile
const createFtpProfile = (data: FtpProfileFormData) => {
  return Api.post({ url: FTP_PROFILE, data })
}

// update an existing FTP Profile
const updateFtpProfile = (id: string, data: Partial<FtpProfileFormData>) => {
  return Api.patch({ url: `${FTP_PROFILE}/${id}`, data })
}

// delete an FTP Profile
const deleteFtpProfile = (id: string) => {
  return Api.delete({ url: `${FTP_PROFILE}/${id}` })
}

export {
  fetchFtpProfiles,
  fetchFtpProfile,
  createFtpProfile,
  updateFtpProfile,
  deleteFtpProfile,
}
